import { localizationMaps } from '../index.js';
import Papa from 'papaparse';

/**
 *
 * @param {*} x
 */
export const numberWithCommas = x => !x ? 0 : typeof x === 'string' ? x : Number(x).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

/**
 *
 * @param {*} string
 */
export const snakeCapitalCase = string => string.replace(/\W+/g, " ").split(/ |\B(?=[A-Z])/).map(word => word.toLowerCase().charAt(0).toUpperCase() + word.slice(1)).join('_');

/**
 *
 * @returns
 */
const parseFile = () => new Promise(resolve => {
  Papa.parse("https://docs.google.com/spreadsheets/d/e/2PACX-1vTi0L6yH9Hb6eC7re-W3c3PlAFTzH0ktkmXE22iuVpyK6wvAMftYNRS0OR3W1Nuy9-_fWx5nHPtCir_/pub?output=csv", {
    download: true,
    header: true,
    complete: results => {
      resolve(results.data);
    }
  });
});

/**
 * 
 * @param {*} address 
 */
export const translateAddress = ({
  addressLineOne,
  addressLineTwo,
  city,
  province,
  postalCode
}) => {
  // Translate the province if found in the dictionary, otherwise return as it is
  const translatedProvince = localizationMaps.fromEnglish("provinces", province);
  const addressParts = [addressLineOne];
  if (addressLineTwo) {
    addressParts.push(addressLineTwo);
  }
  addressParts.push(city, translatedProvince, postalCode);

  // Join the address parts back together
  return addressParts.join(', ');
};

/**
 *
 */
export function fetchTelusDrugIDs() {
  return parseFile();
}